import type { CSSProperties } from 'react';

export interface LogoProps {
  variant?: 'full' | 'icon';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  alt?: string;
  style?: CSSProperties;
}

const sizeMap = {
  sm: 32,
  md: 48,
  lg: 64,
} as const;

const textSizeMap = {
  sm: '20px',
  md: '28px',
  lg: '36px',
} as const;

const ElliIcon = ({ size }: { size: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 92 92"
    width={size}
    height={size}
    aria-hidden="true"
  >
    <rect width="92" height="92" rx="20" fill="#510CFF" />
    <circle cx="32" cy="32" r="13" fill="#20C279" />
    <circle cx="60" cy="32" r="11" fill="#FAFAF4" />
    <circle cx="32" cy="60" r="12" fill="#C8C9FC" />
  </svg>
);

export const Logo = ({
  variant = 'full',
  size = 'md',
  className,
  style,
}: LogoProps) => {
  const iconSize = sizeMap[size];

  if (variant === 'icon') {
    return (
      <div className={className} style={{ display: 'inline-flex', ...style }}>
        <ElliIcon size={iconSize} />
      </div>
    );
  }

  return (
    <div
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        ...style,
      }}
    >
      <ElliIcon size={iconSize} />
      <span
        style={{
          fontSize: textSizeMap[size],
          fontWeight: 800,
          letterSpacing: '-0.04em',
          fontFamily: "'Nunito', system-ui, -apple-system, sans-serif",
          lineHeight: 1,
          color: 'inherit',
          textTransform: 'lowercase' as const,
        }}
      >
        elli
      </span>
    </div>
  );
};
